import { createSelector } from 'reselect'
import { EMPTY_FLIGHT_DATE_CHANGE_SELECTION } from 'constants/flight'
import { getFlightDateChangeMaxSelectableLegIndex, getFlightDateChangeSearchKey } from 'checkout/lib/utils/flights/dateChangeUtils'

export const getFlightDateChangeSelection = (state: App.State) =>
  state.flights.flightsDateChange.flightSelection ?? EMPTY_FLIGHT_DATE_CHANGE_SELECTION

export const getFlightDateChangeMaxSelectableLeg = (state: App.State) =>
  getFlightDateChangeMaxSelectableLegIndex(state.flights.flightsDateChange)

export const getCurrentFlightDateChangeSearchEntry = createSelector(
  (state: App.State) => state.checkout.cart.existingOrder?.flightItems[0]?.reservationId,
  (state: App.State) => state.flights.flightsDateChange?.selectedLegWithNewDepartureDate,
  (state: App.State) => state.flights.flightsDateChangeSearch,
  (reservationId, selectedLegs, searches) => {
    if (!reservationId || !selectedLegs?.length) return undefined
    const key = getFlightDateChangeSearchKey(reservationId, selectedLegs)
    return { key, search: searches[key] }
  },
)

export const getCurrentFlightDateChangeSearchState = (state: App.State) =>
  getCurrentFlightDateChangeSearchEntry(state)?.search
